/**
 * DetailSection — unified section wrapper (TASK-197, contract revised by
 * d2fa004). Moved out of ServiceManagementPage.tsx (KAN-157 god-component
 * split).
 *
 * Renders one of the 5 detail sections. The heading is always an <h4> (the
 * service name stays in <h3>). Emptiness is decided by the caller via an
 * EXPLICIT boolean (not by inspecting React.Children — a `{x && <…>}` child
 * yields false/null and would be misjudged).
 *
 * An empty section renders NOTHING (`return null` below) — d2fa004 replaced the
 * original «пусто» marker with hiding. See ServiceManagementPage.tsx's file
 * header for what that costs: callers must not assume a fixed 5-block card.
 */
export function DetailSection({
  title,
  testid,
  isEmpty,
  children,
}: {
  title: string;
  testid: string;
  isEmpty: boolean;
  children?: React.ReactNode;
}): JSX.Element | null {
  if (isEmpty) return null;
  return (
    <div data-testid={testid}>
      <h4 className="text-sm font-semibold text-gray-700 mb-2">{title}</h4>
      {children}
    </div>
  );
}
